import {
    DIR_LTR,
    DIR_RTL,
    NAV_TYPE_SIDE,
    NAV_TYPE_TOP,
    SIDE_NAV_COLLAPSED_WIDTH,
    SIDE_NAV_WIDTH
} from 'constants/ThemeConstant';
import {
    Grid,
    Layout,
} from "antd";
import React, { useContext } from 'react';

import Footer from 'components/layout-components/Footer';
import { FranchiseeGlobalViews } from 'views/app-views/FranchiseeGlobal';
import HeaderNav from 'components/layout-components/HeaderNav';
import Loading from 'components/shared-components/Loading';
import MobileNav from 'components/layout-components/MobileNav'
import PageHeader from 'components/layout-components/PageHeader';
import SideNav from 'components/layout-components/SideNav';
import TopNav from 'components/layout-components/TopNav';
import { UserContext } from '../../contexts/auth';
import { connect } from 'react-redux';
import navigationConfig from "configs/NavigationConfig";
import { useThemeSwitcher } from "react-css-theme-switcher";
import utils from 'utils';

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const FranchiseeAppLayout = ({ navCollapsed, navType, location, direction }) => {
    const { state } = useContext(UserContext);
    const currentRouteInfo = utils.getRouteInfo(navigationConfig, location.pathname)
    const screens = utils.getBreakPoint(useBreakpoint());
    const isMobile = screens.length === 0 ? false : !screens.includes('lg')
    const isNavSide = navType === NAV_TYPE_SIDE
    const isNavTop = navType === NAV_TYPE_TOP
    const getLayoutGutter = () => {
        if (isNavTop || isMobile) {
            return 0
        }
        return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
    }

    const { status } = useThemeSwitcher();

    if (status === 'loading') {
        return <Loading cover="page" />;
    }

    const getLayoutDirectionGutter = () => {
        if (direction === DIR_LTR) {
            return { paddingLeft: getLayoutGutter() }
        }
        if (direction === DIR_RTL) {
            return { paddingRight: getLayoutGutter() }
        }
        return { paddingLeft: getLayoutGutter() }
    }

    return (

        <Layout>
            <HeaderNav isMobile={isMobile} />
            {(isNavTop && !isMobile) ? <TopNav routeInfo={currentRouteInfo} /> : null}
            <Layout className="app-container">
                {(isNavSide && !isMobile) ? <SideNav routeInfo={currentRouteInfo} /> : null}
                <Layout className="app-layout" style={getLayoutDirectionGutter()}>
                    <div className={`app-content ${isNavTop ? 'layout-top-nav' : ''}`}>
                        <PageHeader display={currentRouteInfo?.breadcrumb} title={currentRouteInfo?.title} />
                        <Content>
                            <FranchiseeGlobalViews />
                        </Content>
                    </div>
                    <Footer />

                </Layout>
            </Layout>

            {isMobile && <MobileNav />}
        </Layout>
    )


}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed, navType, locale } = theme;
    return { navCollapsed, navType, locale }
};

export default connect(mapStateToProps)(FranchiseeAppLayout);